/** `/c/$companyId` — the company's home, on its books (the layout holds it until they are set up). */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { LedgerHome } from "../ledger/LedgerHome";

export const Route = createFileRoute("/_auth/c/$companyId/")({
  component: CompanyHome,
});

function CompanyHome(): JSX.Element {
  const { companyId } = Route.useParams();
  return <LedgerHome companyId={companyId} />;
}
